export default __webpack_public_path__ + "static/media/check-success.303726be.png";